export default "__VITE_ASSET__UKF5w6cUhDaBnvNg9A8J7w__"